/* eslint-disable ember/classic-decorator-no-classic-methods */
import { action } from '@ember/object';
import Controller from '@ember/controller';

export default class IndexController extends Controller {
  queryParams = ['offset'];
  offset = 0;

  @action
  noop() {}

  @action
  refresh() {
    this.model.globalNotices.update();
  }

  @action
  nextPage() {
    this.incrementProperty('offset', 20);
  }

  @action
  prevPage() {
    this.decrementProperty('offset', 20);
  }
}
